import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next'
import Switch from '@material-ui/core/Switch';
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import { getListDatePay } from '../../actions/request'
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import i18next from 'i18next';
import { GetLanguage } from '../../utils/language';
import { loadLocalization } from '../../utils/kendoLocalization';
import DecimalTextField from '../controls/DecimalTextField';
import TextField from "@material-ui/core/TextField";
import MomentUtils from '@date-io/moment';
import moment from "moment";
import "moment/locale/fr";
import * as utils from '../../utils';
import styles from '../../styles/request.module.css';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as storage from '../../utils/storage'
import TimeTextField from '../controls/TimeTextField';
import { Popup } from "@progress/kendo-react-popup";

loadLocalization();
moment.locale("fr");

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: '5px'
    },
    switchLabelComponent: {
        justifyContent: 'left'
    },
    labelInput: {
        left: 'unset !important',
        top: 'unset !important'
    }
}))

const TimeControls = (props) => {
    return (
        <FormControl fullWidth className={styles.timeParent}>
            <TimeTextField
                id="startTime"
                name="startTime"
                label={i18next.t('request:form.from')}
                handleChange={props.onChangeStartTime}
                value={props.startTime}
                onFocus={props.handleFocus}
            />

            <TimeTextField
                id="endTime"
                name="endTime"
                label={i18next.t('request:form.to')}
                handleChange={props.onChangeEndTime}
                className={styles.divInput}
                value={props.endTime}
                onFocus={props.handleFocus}
            />
        </FormControl>
    )
};

function VacationRequestForm(props) {

    const [isPartial, setIsPartial] = React.useState(false);
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [returnDate, setReturnDate] = React.useState(null);
    const [payAdvance, setPayAdvance] = React.useState(false);
    const [datePay, setDatePay] = React.useState(null);
    const [comment, setComment] = React.useState(null);
    const [duration, setDuration] = React.useState(null);
    const [isScheduleDate, setIsScheduleDate] = React.useState(false);
    const [isPartialRequestHoursUsed, setIsPartialRequestHoursUsed] = React.useState(false);
    const [locale, setLocale] = React.useState('fr');
    const [datePayList, setDatePayList] = React.useState(null);
    const [startTime, setStartTime] = React.useState(null);
    const [endTime, setEndTime] = React.useState(null);


    const { onChange } = props;
    const isDisplayPayAdvanceVacation = storage.getIsDisplayPayAdvanceVacation();
    const isUsePartialRequest = storage.getIsUsePartialRequest();

    useEffect(() => {
        const language = GetLanguage();
        moment.locale(language);
        setLocale(language);
        setIsScheduleDate(storage.getScheduleReturnDate());
        setIsPartialRequestHoursUsed(storage.getPartialRequestHoursUsed());
    }, [])

    useEffect(() => {
        if (payAdvance && startDate !== null) {
            loadDatePay();
        }
    }, [payAdvance, startDate])

    useEffect(() => {
        onChangeForm();
    }, [startDate, endDate, returnDate, isPartial, duration, payAdvance, datePay, comment, startTime, endTime])

    useEffect(() => {
        calculateDuration();
    }, [startTime, endTime])

    const onChangePartial = (event) => {
        setIsPartial(event.target.checked);
        if (isPartialRequestHoursUsed) {
            setStartTime(null);
            setEndTime(null);
        }
    }

    const onStartDateChange = (event) => {
        setStartDate(event.target.value);
    }

    const onEndDateChange = (event) => {
        setEndDate(event.target.value);
    }

    const onReturnDateChange = (event) => {
        setReturnDate(event.target.value);
    }

    const onChangeComment = (event) => {
        setComment(event.target.value);
    }

    const onChangePayAdvance = (event) => {
        setPayAdvance(event.target.checked);
    }

    const onChangeDatePay = (event) => {
        setDatePay(event.target.value);
    }

    const onChangeDuration = (event) => {
        setDuration(event.target.value);
    }

    const onChangeForm = () => {
        onChange(startDate, endDate, returnDate, isPartial, duration, payAdvance, datePay, comment, startTime, endTime);
    }

    const handleFocus = (event) => {
        // this should be good on desktop and android
        //event.target.select();

        // workaround to make it work in iOS
        event.target.setSelectionRange(0, event.target.value.length);
    }

    const loadDatePay = async () => {
        const startDatePay = utils.formatDate(new Date(), 'date');
        const endDatePay = utils.formatDate(startDate);

        const result = await getListDatePay(startDatePay, endDatePay);

        if (result !== undefined) {
            setDatePayList(result.datePayList);
        }
    }

    const onChangeStartTime = (event) => {
        let value = toTimePickerFormat(event.target.value);
        if (validateTime(value)) {
            const start = utils.formatTime(value);
            setStartTime(start);
        } else if (value.length == 1) {
            setStartTime(value);
        } else if (value == '') {
            setStartTime('');
        }
    }

    const onChangeEndTime = (event) => {
        let value = toTimePickerFormat(event.target.value);
        if (validateTime(value)) {
            const end = utils.formatTime(value);
            setEndTime(end);
        } else if (value.length == 1) {
            setEndTime(value);
        } else if (value == '') {
            setEndTime('');
        }
    }

    const toTimePickerFormat = (value) => {
        if (value) {
            try {
                let hours = '00';
                let minutes = '00';
                let result = value.replace(/[,.]/g, ':');
                let isnum = /^\d+$/.test(result);

                if (!result.includes(':') || (result.length > 5)) {
                    if (result.length == 1) {
                        return result;
                    } else if (result.length == 2) {
                        hours = result;
                    } else if (result.length > 2 && isnum) {
                        hours = result.substring(0, 2);
                        minutes = result.substring(2, result.length)
                    } else {
                        return '';
                    }
                }
                else {
                    const arrayTime = result.split(':');

                    hours = arrayTime[0];
                    minutes = arrayTime[1];

                    if ((hours.length > 2) || (minutes.length > 2)) {
                        return '';
                    }

                    if (hours.length == 0) {
                        hours = '00';
                    } else if (hours.length == 1) {
                        hours = '0' + hours;
                    }

                    if (minutes.length == 0) {
                        minutes = '00';
                    }
                    else if (minutes.length == 1) {
                        minutes = minutes + '0';
                    }
                }

                if (parseFloat(hours) > 23) {
                    return '';
                }
                if (parseFloat(minutes) > 59) {
                    return '';
                }

                return hours + ':' + minutes;
            }
            catch {
                return '';
            }
        }

        return '';
    }

    const calculateDuration = () => {
        var startDecimal = 0;
        var endDecimal = 0;

        if (validateTime(startTime) && validateTime(endTime)) {
            let startDate = new Date("2022-09-14 " + startTime);
            let endDate = new Date("2022-09-14 " + endTime);

            startDecimal = parseFloat(startDate.getHours() + "." + startDate.getMinutes().toString().padStart(2, '0'));
            startDecimal = Math.floor(startDecimal) + (parseFloat((startDecimal - Math.floor(startDecimal)).toFixed(2)) / 60 * 100);
            endDecimal = parseFloat(endDate.getHours() + "." + endDate.getMinutes().toString().padStart(2, '0'));
            endDecimal = Math.floor(endDecimal) + (parseFloat((endDecimal - Math.floor(endDecimal)).toFixed(2)) / 60 * 100);

            let timeDiffMS = endDecimal - startDecimal;
            if (timeDiffMS < 0) {
                timeDiffMS = timeDiffMS + 24;
            }

            if (timeDiffMS >= 0) {
                setDuration(timeDiffMS);
            } else {
                setDuration(0);
            }
        } else {
            setDuration(0);
        }
    }

    const validateTime = (value) => {
        var isValid = /^([01]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/.test(value);

        return isValid;
    }

    const classes = useStyles();

    let _el;

    return (
        <div>
            <LocalizationProvider language={locale}>
                <IntlProvider locale={locale}>
                    {isUsePartialRequest && <FormControl className={styles.switchComponent}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isPartial}
                                    onChange={onChangePartial}
                                    name="partialVacation"
                                    variant="success"
                                />
                            }
                            label={i18next.t("request:form.partial")}
                            labelPlacement="start"
                        />
                    </FormControl>}

                    <div className={styles.divDate} ref={el => (_el = el)}>
                        <InputLabel className={"labelDatePicker required"} htmlFor="startDate">{i18next.t('request:form.startDate')}</InputLabel>
                        <DatePicker
                            className={styles.inputDate}
                            name="startDate"
                            value={startDate}
                            onChange={onStartDateChange}
                            format="yyyy-MM-dd"
                            popup={props => <Popup {...props} appendTo={_el} />}
                        />
                    </div>

                    {!isPartial &&
                        <div className={styles.divDate} ref={el => (_el = el)}>
                            <InputLabel className={"labelDatePicker required"} htmlFor="endDate">{i18next.t('request:form.endDate')}</InputLabel>
                            <DatePicker
                                className={styles.inputDate}
                                name="endDate"
                                value={endDate}
                                onChange={onEndDateChange}
                                format="yyyy-MM-dd"
                                popup={props => <Popup {...props} appendTo={_el} />}
                            />
                        </div>}

                    {isScheduleDate &&
                        <div className={styles.divDate} ref={el => (_el = el)}>
                            <InputLabel className={"labelDatePicker required"} htmlFor="returnDate">{i18next.t('request:form.scheduleReturnDate')}</InputLabel>
                            <DatePicker
                                className={styles.inputDate}
                                name="returnDate"
                                value={returnDate}
                                onChange={onReturnDateChange}
                                format="yyyy-MM-dd"
                                popup={props => <Popup {...props} appendTo={_el} />}
                            />
                        </div>}

                    {(isPartial && isPartialRequestHoursUsed) &&
                        <TimeControls
                            onChangeStartTime={onChangeStartTime}
                            onChangeEndTime={onChangeEndTime}
                            startTime={startTime}
                            endTime={endTime}
                            handleFocus={handleFocus}
                        />
                    }

                    {isPartial && <FormControl fullWidth className={styles.divInput}>
                        <DecimalTextField
                            id="durationVacation"
                            name="durationVacation"
                            label={`${i18next.t('request:form.duration')} (${i18next.t('request:form.hour')})`}
                            handleChange={onChangeDuration}
                            className={styles.inputDuration}
                            value={duration}
                            onFocus={handleFocus}
                            decimalScale={2}
                            disabled={(isPartial && isPartialRequestHoursUsed)}
                            className={'required'}
                        >
                        </DecimalTextField>
                    </FormControl>
                    }

                    <FormControl fullWidth className={styles.divInput}>
                        {isDisplayPayAdvanceVacation &&
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={payAdvance}
                                        onChange={onChangePayAdvance}
                                        name="partialVacation"
                                        variant="success"
                                    />
                                }
                                label={i18next.t("request:form.vacation.paidAdvance")}
                                labelPlacement="start"
                                className={classes.switchLabelComponent}
                            />}

                        {payAdvance && <div className={styles.divFormSelect}>
                            <InputLabel className={'required ' + classes.labelInput} id="label-payDate">{i18next.t('request:form.vacation.payDate')}</InputLabel>
                            <Select
                                labelId="label-payDate"
                                id="payDate"
                                displayEmpty
                                value={datePay || ''}
                                onChange={onChangeDatePay}
                                className={styles.divFullWidth}
                            >
                                {datePayList && datePayList.map((obj, index) =>
                                    <MenuItem key={index} className={styles.selectItem} value={obj.value}>{obj.descriptionFr}</MenuItem>
                                )}
                            </Select>
                        </div>}
                    </FormControl>

                    <FormControl fullWidth className={styles.divInput}>
                        <TextField
                            id="comments"
                            label={i18next.t('request:form.comment')}
                            multiline
                            minRows={4}
                            className={styles.inputComments}
                            value={comment || ''}
                            onChange={onChangeComment}
                        />
                    </FormControl>
                </IntlProvider>
            </LocalizationProvider>
        </div>
    )
}

export default withNamespaces(['request'], { wait: true })(VacationRequestForm);

VacationRequestForm.propTypes = {
    onChange: PropTypes.func.isRequired
}